require('intersection-observer');
import Vue from 'vue';
import "core-js/stable";
import "regenerator-runtime/runtime";
import 'picturefill';
import objectFitImages from 'object-fit-images';
import VuePrlx from 'vue-prlx';
Vue.use(VuePrlx);
import lottie from 'lottie-web';
import { Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import axios from 'axios';
objectFitImages();
// =============================
// ユーザーエージェント判定
// =============================
var UA = navigator.userAgent.toLowerCase();
if(UA.indexOf('msie') != -1 || UA.indexOf('rv:11.0') != -1){
	// IEの時
	document.body.classList.add('__isIE');
}else{
	document.body.classList.add('__isNotIE');

}
// ロードアニメーション
var loadanim = function(){
    setTimeout( function(){
		document.body.classList.remove('disable-js');
	}, 300 );
};
window.onload = loadanim;
// SEO設定
var obj = document.getElementById("footer_txt");
var parent = document.getElementById("footer");
var target = document.getElementById("footer_linklist");
parent.insertBefore(obj, target);
var obj = document.getElementById("linklist");
target.appendChild(obj);

// intersectionObserver
Vue.component('IntersectionObserver', {
	props: {
		sentinalName: {
			type: String,
			required: true,
		},
	},
	template:`
		<div :ref="sentinalName" class="" />
	`,
	data(){
		return {
			isIntersectingElement: false,
		}
	},
	watch: {
		isIntersectingElement: function(value) {
			this.$emit('on-intersection-element', value)
		},
	},
	mounted() {
		const sentinal = this.$refs[this.sentinalName]
		const handler = (entries) => {
			if (entries[0].isIntersecting) {
				this.isIntersectingElement = true
			} 
			else {
				this.isIntersectingElement = false
			}
		}
		const observer = new window.IntersectionObserver(handler, {threshold: 0.4})
		observer.observe(sentinal)
	},
});


var timeout;
// ナビコンポーネント
Vue.component('nav-accordion', {
	props: [ 'url', 'controls', 'class'],
	template: `
		<li class="__hasChildren" 
			:class="{'__isOpen' : isOpen}" 
			v-on:mouseenter="!isMobile && winWidth >= 1100 ? mouseEnter() : null" 
			v-on:mouseleave="!isMobile && winWidth >= 1100 ? mouseLeave() : null"
			>
			<a :href="url" :aria-controls="controls" 
				v-on:click="isMobile || winWidth < 1100 ? accordionToggle($event) : null"
			>
				<slot name="trigger"></slot>
			</a>
			<slot name="target"></slot>
		</li>
		`,
	data() {
		return {
			isOpen: false,
			isMobile: false
		};
	},
	mounted() {
		this.$nextTick(function(){
			this.isMobile = headerVm.isMobile;
			this.winWidth = headerVm.winWidth;
		})
	},
	computed: {
		winWidth: function(){
			return headerVm.winWidth
		}
	},
	methods: {
		accordionToggle: function(event){
			if(event){
				event.preventDefault();
			}
			this.isOpen = !this.isOpen;
		},
		mouseEnter: function(){
			this.isOpen = true;
		},
		mouseLeave: function(){
			this.isOpen = false;
		}
	}
});
// アコーディオンコンポーネント
Vue.component('accordion', {
	props: [ 'controls', 'class'],
	template: `
		<dl 
			:class="{'__isOpen' : isOpen}"
		>
			<dt 
				:aria-controls="controls" 
				role="tab"
				:aria-selected="isOpen ? 'true' : 'false'"
				:aria-expanded="isOpen ? 'true' : 'false'"
				v-on:click="accordionToggle()"
			>
				<slot name="trigger"></slot>
			</dt>
			<dd
				role="tabpanel"
				:id="controls"
				:aria-hidden="isOpen ? 'false' : 'true'"
			>
				<slot name="target"></slot>
			</dd>
		</dl>
		`,
	data() {
		return {
			isOpen: false
		};
	},
	methods: {
		accordionToggle: function(){
			this.isOpen = !this.isOpen;
		}
	}
});
// スライドショーコンポーネント
Vue.component('slide-show', {
	props: {
		sectionClass: String,
		itemClass: String,
		picClass: String,
		items: Array
	},
	data(){
		return {
			current: 0,
			num: this.items.length,
			isReady: false
		}
	},
	computed: {
		before: function(){
			return this.current == 0 ? this.num - 1 : this.current - 1
		}
	},
	template:
	` 
		<section :class="sectionClass">
		<div v-for="(item, index) in items" :class="[itemClass, index == current ? '__isCurrent': '__isHidden', index == before ? '__isBefore':'', ( (index == current || index == before ) && isReady)? '__isActive':'']">
			<picture :class="[picClass,item.subclass]">
				<source media="(min-width: 1100px)" v-bind:srcset="item.pc">
				<source media="(min-width: 768px)" v-bind:srcset="item.tab">
				<img class="anim" v-bind:srcset="item.sp" v-bind:alt="item.caption">
			</picture>
		</div>
		<slot></slot>
		</section>
	`,
	methods: {
		slide(){
			this.current = this.current < this.num -1 ? this.current +1 : 0;
		}
	},
	watch: {
		isReady: function(val){
			if(val){
				setInterval(() => {
					this.slide();
				}, 5000)
			}
		}
	},
	mounted() {
	　　this.isReady = true;
	}
});
// スマホハンバーガーメニュー,スクロール判定
var headerVm = new Vue({
	el: '#header',
	data: {
		activeClass: '',
		isActive: false,
		isMobile: false,
		winWidth: window.innerWidth
	},
	created: function(){
		if (
			navigator.userAgent.indexOf('iPhone') > 0 ||
			navigator.userAgent.indexOf('Android') > 0 &&
			navigator.userAgent.indexOf('Mobile') > 0
		) {              
			this.isMobile = true;          
		} else if (
			navigator.userAgent.indexOf('iPad') > 0 || 
			navigator.userAgent.indexOf('Android') > 0
		) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	},
	methods: {
		toggleMenu: function(){
			this.isActive = !this.isActive;
			this.activeClass = this.isActive ? '__isOpen' : '__isClosed' ;
		},
		handleResize: function(){
			this.winWidth = window.innerWidth;
		}
		
	},
	mounted: function(){
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy: function(){
		window.removeEventListener('resize', this.handleResize)
	},
	watch: {
		isActive: function(val) {
			if(val){
				document.body.classList.add('__fixed');
			}else{
				document.body.classList.remove('__fixed');
			}
		}
	}
});
var PagetopBtn = document.getElementById('btnPagetop');
PagetopBtn.addEventListener('click', () => {
	window.scroll({
		top: 0,
		behavior: 'smooth'
	})
});
// アニメーション
Vue.component('tulip-anim', {
	props: {
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	template: `
			<div class="tulip-anim" :class="{'__isShow': startAnim == 2 }">
				<div class="tulip-anim_bg" :class="{'__isShow': showBg }"></div>
				<div id="opening01" class="tulip-anim_item __line"></div>
				<div id="opening02" class="tulip-anim_item __color"></div>
				<div class="tulip-anim_logo" :class="{'__isShow': logo}">
					<img srcset="/common/img/ico_logoL@2x.png 2x, /common/img/ico_logoL.png" />
				</div>
				<p class="tulip-anim_skip" v-show="isTop" v-on:click="$emit('skip')">スキップ</p>
			</div>
		`,
	data() {
		return {
			logo: false,
			startAnim: 0,
			showBg: false,
			finished: false,
			isReady: this.isLoading,
			tulipanim01: null,
			tulipanim02: null,
			isTop: this.isLoading
		};
	},
	mounted(){
		const self = this;
		const openingCnt01 = document.getElementById('opening01'),
			openingCnt02 = document.getElementById('opening02');
		this.tulipanim01 = lottie.loadAnimation({
			container: openingCnt01,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: '/common/lottie/data01.json',
		});
		this.tulipanim02 = lottie.loadAnimation({
			container: openingCnt02,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			path: '/common/lottie/data02.json',
		});
		this.tulipanim01.addEventListener('data_ready', e=>{
			this.startAnim++;
		});
		this.tulipanim02.addEventListener('data_ready', e=>{
			this.startAnim++;
		});
		this.tulipanim01.addEventListener('complete', e=> {
			setTimeout(function(){
				self.logo = true;
			}.bind(this), 1000);
			const setFinished = () => {
				self.finished = true;
				main.isLoaded = true;
				loading.isLoaded = true;
				if(this.isTop){
					document.body.classList.remove('__fixed');
				}
			}
			setTimeout(setFinished.bind(this), 4500);
		});
	},
	methods: {
		start(){
			const self = this;
			setTimeout(function(){
				self.tulipanim01.play();
				// self.tulipanim02.play();
				self.showBg = true;
			}.bind(this),2000);
		},
		skipAnim(){
			this.finished = true;
			main.isLoaded = true;
			loading.isLoaded = true;
			if(this.isTop){
				document.body.classList.remove('__fixed');
			}
		}
	},
	watch: {
		startAnim: function(val){
			const isTop = this.isTop;
			if(val == 2){
				if(this.isReady){
					if(isTop == true){
						document.body.classList.add('__fixed');
					}
					this.start();
				}
			}
		},
		isReady: function(val){
			const isTop = this.isTop;
			if(val == true){
				if(this.startAnim == 2){
					if(isTop == true){
						document.body.classList.add('__fixed');
					}
					this.start();
				}
			}
		}
	},
});

var main = new Vue({
	el: '#main',
	components: {
		Hooper,
		Slide,
		HooperNavigation,
	},
	data(){
		return {
			hooperSettings: {
				itemsToShow: 1,
				infiniteScroll: true,
				wheelControl: false
			},
			movieHooperSettings: {
				itemsToShow: 1,
				infiniteScroll: false,
				wheelControl: false,
				breakpoints: {
					767: {
					 	itemsToShow: 4
					}

				}
			},
			checkedAreas: [],
			checkedService: [],
			checkedType: [],
			branches: null,
			filteredBranches: null,
			hasNoResult: 0,
			isLoaded: false,
			isIntersectingElement: false
		};
	},
	mounted(){
		axios
			.get('/branch/branches.json')
			.then(response => (this.branches = response.data.items));
	},
	computed: {
		isMapActive: function(){
			return function(key){
				if(this.checkedAreas.includes(key)){
					return true;
				}else{
					return false;
				}
			}
		}
	},
	watch: {
		isLoaded(){
			if(this.$refs.slideshow){
				this.$refs.slideshow.isReady = true;
			}
		}
	},
	methods: {
		slidePrev() {
			this.$refs.carousel.slidePrev();
		},
		slideNext() {
			this.$refs.carousel.slideNext();
		},
		updateCarousel(payload){
			this.myCarouselData = payload.currentSlide;
		},
		changeCarouselData(i){
			this.$refs.carousel.slideTo(i - 1);
		},
		toggleArea(area){
			var arr = this.checkedAreas;
			if(arr.includes(area)){
				var index = arr.findIndex((u) => u === area);
				arr.splice(index, 1);
			}else{
				arr.push(area);
			}
		},
		searchBranches(){
			var arr = this.branches;
			var areaArray = this.checkedAreas;
			var serviceArray = this.checkedService;
			var typeArray = this.checkedType;
			var filteredData = arr;
			if(areaArray.length){ // エリアでor検索
				var checkedAreas = areaArray.join('|');
				var reg = new RegExp(checkedAreas);
				filteredData = filteredData
				.filter(data => reg.test(data.area));
			}
			if(serviceArray.length){ // サービスでor検索
				var checkedService = serviceArray.join('|');
				var reg = new RegExp(checkedService);
				filteredData = filteredData
				.filter(data => reg.test(data.service));
			}
			if(typeArray.length){ // タイプでor検索
				var checkedType = typeArray.join('|');
				var reg = new RegExp(checkedType);
				if(filteredData.length){
					filteredData = filteredData
					.filter(data => reg.test(data.type));
				}
			}
			if(filteredData.length){
				this.filteredBranches = filteredData;
				this.hasNoResult = 0;
			}else{
				this.filteredBranches = null;
				this.hasNoResult = 1;
			}
		},
		onIntersectionAboutTulip(val){
			this.isIntersectingElement = val;
			this.$refs.tulip.isReady = val;
		}
	},
});
var loading = new Vue({
	el: '#loading',
	data(){
		return {
			isLoaded: false
		}
	}
});